import styled, { css } from 'styled-components';
import { Modal } from '@mui/material';
import { motion } from 'framer-motion';
import { breakpoints } from 'styles/breakpoints';

export const StyledDailyBonusModal = styled(Modal)`
  font-family: var(--font-family);

  overflow: auto;

  &.modal-preview {
    position: absolute !important;

    .MuiBackdrop-root.MuiModal-backdrop {
      position: absolute !important;
    }

    .daily-bonus-border {
      --banner-width-px: 340px;
      --popup-banner-ratio: 1 / 1;
    }

    .daily-bonus-border {
      --banner-width-px: 340px;
      --popup-banner-ratio: 1 / 1;
    }
  }

  &__preview {
    position: absolute !important;
    overflow: hidden;

    .MuiBackdrop-root.MuiModal-backdrop {
      position: absolute !important;
    }

    .daily-bonus-border {
      --banner-width-px: 340px;
      --popup-banner-ratio: 1 / 1;
    }
  }
`;

export const StyledClaimTitle = styled.div`
  font-family: var(--font-family);

  font-size: 22px;
  font-weight: 400;
  color: #c89612;
`;

export const StyledDailyBonusBorder = styled(motion.div)`
  font-family: var(--font-family);

  margin: auto;
  --banner-width-px: 400px;
  width: 100%;
  max-width: var(--banner-width-px);
  padding: 2px;

  &.spin-x,
  &.cash-frenzy {
    --banner-width-px: 342px;
  }

  @media (max-width: 480px) {
    --banner-width-px: 343px;
  }

  @media (max-width: 340px) {
    --banner-width-px: 300px;
  }

  &:focus-visible {
    outline: none;
  }

  * {
    box-sizing: border-box;
  }
`;

export const StyledPopup = styled.div`
  :focus-visible {
    outline: none;
  }

  width: 100%;
  height: 100%;

  .daily-bonus-banner {
    font-family: var(--font-family), Arial;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: transparent;
    border-radius: 15px;
    padding: 15px;
    position: relative;
    width: inherit;
    height: inherit;

    &.spin-x {
      border-radius: 20px;

      .daily-bonus-banner__title {
        text-shadow: 1px 1px 1px #000, -1px -1px 1px #000, 1px -1px 1px #000,
          -1px 1px 1px #000;
      }

      .quantity-wrapper {
        color: #fde60a;
        text-shadow: 1px 1px 1px #8c0000, -1px -1px 1px #8c0000,
          1px -1px 1px #8c0000, -1px 1px 1px #8c0000;
      }

      .daily-bonus-banner__action-button {
        min-height: 32px;
        height: 32px;
        border-radius: 100px;
        text-shadow: 1px 1px 1px #000, -1px -1px 1px #000, 1px -1px 1px #000,
          -1px 1px 1px #000;
        font-weight: 950;
        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25),
          0 -2px 1.8px 0 #3e7e0f inset, 0 1px 1px 0 #a4ee13 inset,
          0 2px 1px 0 #edfe33 inset;

        &--disabled {
          box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25),
            0 -2px 1.8px 0 #848484 inset, 0 1px 1px 0 #f2f2f2 inset,
            0 2px 1px 0 #fff inset;
        }
      }
    }

    &.cash-frenzy {
      border-radius: 20px;

      .daily-bonus-banner__title {
        color: #fee810;
        text-shadow: 1px 1px 1px #9c3f2c, -1px -1px 1px #9c3f2c,
          1px -1px 1px #9c3f2c, -1px 1px 1px #9c3f2c;
        font-weight: 850;
      }

      .quantity-wrapper {
        color: #fee810;
        text-shadow: 1px 1px 1px #731c0a, -1px -1px 1px #731c0a,
          1px -1px 1px #731c0a, -1px 1px 1px #731c0a;
      }

      .daily-bonus-banner__action-button {
        min-height: 40px;
        height: 40px;
        border-radius: 8px;
        text-shadow: 1px 1px 1px #074106, -1px -1px 1px #074106,
          1px -1px 1px #074106, -1px 1px 1px #074106;
        font-weight: 850;
        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25), 0 -2px 1px 0 #035f01 inset,
          0 4px 2px 0 #92fb03 inset, 0 2px 1px 0 #edfe33 inset;

        &--disabled {
          background: linear-gradient(180deg, #b39ae7 0%, #876fbb 100%);
          box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25),
            0 -2px 1px 0 #533a87 inset, 0 4px 2px 0 #cfb9ff inset,
            0 2px 1px 0 #edfe33 inset;
          text-shadow: 1px 1px 1px #331a67, -1px -1px 1px #331a67,
            1px -1px 1px #331a67, -1px 1px 1px #331a67;

          div {
            color: #dfd0ff !important;

            img {
              display: none;
            }
          }
        }
      }
    }

    ${(props: any) =>
      props.backgroundImage &&
      css`
        background-image: url(${props.backgroundImage});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
      `}
    &__close-icon {
      padding: 10px;
      position: absolute;
      top: 0;
      right: 0;
      border: unset;
      background: unset;

      &:hover {
        cursor: pointer;
      }
    }

    &__title {
      font-size: ${(props: any) => props?.titleSize};
      font-weight: ${(props: any) => props?.titleWeight};
      color: ${(props: any) => props?.titleColor};
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 100%;
    }

    &__action-button {
      font-size: 24px;
      text-shadow: 0 1px 1px black;
      box-shadow: inset 0 -4px 0 rgba(0, 0, 0, 0.3);

      .stroked {
        text-decoration-line: line-through;
        text-decoration-color: #d8232a;
        text-decoration-thickness: 2px;
        display: flex;
        align-items: center;
        font-size: 20px;
      }

      &--disabled {
        cursor: default;

        img {
          margin-right: 5px;
          height: 18px;
        }
      }
    }

    &__product-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: white;
      width: 100%;

      &__product-amount {
        text-shadow: 0px 1px 1px #000;
        font-size: 20px;
        font-weight: 700;
      }
    }
  }
` as any;

export const StyledCollectButton = styled.div`
  background-image: ${(props: any) => `url("${props.background}")`};
  background-size: 100% 100%;
  background-position: center;
  height: 60px;
  width: 172px;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0;
  left: 0;
  cursor: pointer;

  font-weight: 700;
  font-size: 24px;
  color: white;
` as any;
